module.exports = __webpack_public_path__ + "static/media/coin_img.63b7a228.png";